import React from "react";

const Hero: React.FC = () => {
    return (
      <div className="flex items-center justify-center h-screen">
        <section style={{ padding: '60px 20px', textAlign: 'center' }}>
        <h1 className="syne-heavy-gradient" style={{ margin: 0, fontSize: '4rem' }}>Yago Torres</h1>

        <h2 style={{ fontSize: '1.5rem', color: '#d6cbcb', margin: '10px 0' }}>
        Computer Science Student at HTWG Konstanz
        </h2>
        <p className="raleway-light" style={{ fontSize: '1.2rem', maxWidth: '600px', margin: '0 auto', color: '#ffffff' }}>
        Passionate about computers, music, and learning new technologies.
        </p>
    </section>
</div>
    );
};

export default Hero;